const namespace = "payments";

export const ACTIVATE_CITY_TAX_PAYMENT = `${namespace}/Activate City Tax Payment`;
export const ACTIVATE_CITY_TAX_PAYMENT_SUCCESS = `${namespace}/Activate City Tax Payment Success`;
export const ACTIVATE_CITY_TAX_PAYMENT_FAIL = `${namespace}/Activate City Tax Payment Fail`;

export const CONFIRM_CITY_TAX_PAYMENT = `${namespace}/Confirm City Tax Payment`;
export const CONFIRM_CITY_TAX_PAYMENT_SUCCESS = `${namespace}/Confirm City Tax Payment Success`;
export const CONFIRM_CITY_TAX_PAYMENT_FAIL = `${namespace}/Confirm City Tax Payment Fail`;

export const ACTIVATE_RESERVATIONS_PAYMENT = `${namespace}/Activate Reservations Payment`;
export const ACTIVATE_RESERVATIONS_PAYMENT_SUCCESS = `${namespace}/Activate Reservations Payment Success`;
export const ACTIVATE_RESERVATIONS_PAYMENT_FAIL = `${namespace}/Activate Reservations Payment Fail`;

export const CONFIRM_RESERVATIONS_PAYMENT = `${namespace}/Confirm Reservations Payment`;
export const CONFIRM_RESERVATIONS_PAYMENT_SUCCESS = `${namespace}/Confirm Reservations Payment Success`;
export const CONFIRM_RESERVATIONS_PAYMENT_FAIL = `${namespace}/Confirm Reservations Payment Fail`;

export const CREATE_SETUP_INTENT = `${namespace}/Create Setup Intent`;
export const CREATE_SETUP_INTENT_SUCCESS = `${namespace}/Create Setup Intent Success`;
export const CREATE_SETUP_INTENT_FAIL = `${namespace}/Create Setup Intent Fail`;

export const CREATE_PAYMENT_INTENT = `${namespace}/Create Payment Intent`;
export const CREATE_PAYMENT_INTENT_SUCCESS = `${namespace}/Create Payment Intent Success`;
export const CREATE_PAYMENT_INTENT_FAIL = `${namespace}/Create Payment Intent Fail`;

export const CREATE_CITY_TAX_PAYMENT_INTENT = `${namespace}/Create City Tax Payment Intent`;
export const CREATE_CITY_TAX_PAYMENT_INTENT_SUCCESS = `${namespace}/Create City Tax Payment Intent Success`;
export const CREATE_CITY_TAX_PAYMENT_INTENT_FAIL = `${namespace}/Create City Tax Payment Intent Fail`;

export const GET_CONNECT_ACCOUNT_ID = `${namespace}/Get Connect Account ID`;
export const GET_CONNECT_ACCOUNT_ID_SUCCESS = `${namespace}/Get Connect Account ID Success`;
export const GET_CONNECT_ACCOUNT_ID_FAIL = `${namespace}/Get Connect Account ID Fail`;
